import React, { useState, useEffect } from "react"
import Layout, { MyLocationEnum } from "../components/Layout"
import SEO, { MetaOG } from "../components/Seo"
import { graphql } from "gatsby"
import { TransitionStatus } from "react-transition-group/Transition"
import MobileStoryRoom from "../components/StoryRooms/MobileStoryRoom"
import BannerImage from "../images/haustradstefnaSocial.png"
import { StoryItemProps } from "../components/StoryRooms/StoryItem";
const LazyApp = React.lazy(() => import('../components/App/App'));

import {
  ChatEmbed,
  ChatSideBar,
  useChat,
  CHAT_NAME,
  SubroomNameEnum
} from '../components/Chat'
import ChatMobile from "../components/Chat/ChatMobile"
import styled from "styled-components"

interface StoryRoomProps {
  data: any,
  location: Location,
  transitionStatus: TransitionStatus,
}

export default ({ data, location, transitionStatus }: StoryRoomProps) => {

  const seo_og: MetaOG = {
    title: "Önnur hæð og IT",
    description: "",
  }

  const [showMobile, setShowMobile] = useState(false)
  useEffect(() => {
    var resp = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    setShowMobile(resp)
  })

  const isSSR = typeof window === "undefined"

  const firstImageLayout: StoryItemProps = {
    xPos: "20%",
    yPos: "20%",
    heightPercentage: "60%",
    widthPercentage: "40%"
  }

  const {
    chatNickname,
  } = useChat()

  if (!showMobile) {
    return (
      <Layout
        myLocation={MyLocationEnum.OnnurHaed}
        location={location}
        transitionStatus={transitionStatus}
        showMessage={true}
      >
        {({ infoOpen, messageOpen, setMessageOpen }) => (
          <>
            <SEO
              title="Nærmynd"
              description=""
              og={seo_og}
            />

            <ChatSideBar onClose={() => setMessageOpen(false)} show={messageOpen}>
            {chatNickname.fetching === false && (
                <ChatEmbed
                  chatName={CHAT_NAME}
                  nickname={chatNickname.nickname}
                  subroom={SubroomNameEnum.Onnurhaedogit}
                />
              )}
            </ChatSideBar>

            {!isSSR && (
              <React.Suspense fallback={<div />}>
                <LazyApp
                  data={data}
                  transitionStatus={transitionStatus}
                  topColor="linear-gradient(180deg, rgba(59,133,240,1) 0%, rgba(255,255,255,1) 94%)"
                  floorColor="linear-gradient(180deg, rgba(122,166,29,1) 0%, rgba(255,255,255,1) 94%)"
                  rightColor="#fff"
                  leftColor="#fff"
                  firstImageLayout={firstImageLayout}
                />
              </React.Suspense>
            )}
          </>
        )}
      </Layout>
    )
  } else {
    return (
      <LayoutMobile
        myLocation={MyLocationEnum.OnnurHaed}
        location={location}
        transitionStatus={transitionStatus}
      >
        <SEO
          title="Nærmynd"
          description="Ýmsar sögur úr bransanum"
          og={seo_og}
        />

        {chatNickname.fetching === false && (
          <ChatMobile>
            <ChatEmbed
              chatName={CHAT_NAME}
              nickname={chatNickname.nickname}
              subroom={SubroomNameEnum.Onnurhaedogit}
            />
          </ChatMobile>
        )}

      </LayoutMobile>
    )
  }
}

const LayoutMobile = styled(Layout)`
  background: #5166E7;
`

export const query = graphql`
  query {
    ceiling: file(relativePath: { eq: "Loft-1.png" }) {
      childImageSharp {
        fluid(maxWidth: 1500, quality: 50) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    floor: file(relativePath: { eq: "squoosh_roomFloor.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500, quality: 50) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    concreteWall: file(relativePath: { eq: "Spacetile.png" }) {
      childImageSharp {
        fluid(maxWidth: 1500, quality: 50) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    allRoom(filter: {roomName: {eq: "onnurhaedogit"}}) {
      edges {
        node {
          firstImageNode {
            publicURL
          }
          thirdImageNode {
            publicURL
          }
        }
      }
    }
  } 
`